
import { HuntrixSong } from './types';

export const WILL_HE_LET_THE_FIRE_GO_OUT: HuntrixSong = {
    id: 'WILL_HE_LET_THE_FIRE_GO_OUT',
    title: "Will He Let The Fire Go Out",
    artist: "Jinu",
    midiFileName: "WillHeLetTheFireGoOut.mid",
    mp3FileName: "WillHeLetTheFireGoOut.mp3",
    sequencedTracks: [
        {
            "name": "Koto",
            "notes": [
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "0:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "1:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "1:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "1:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "1:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "2:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "4:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "11:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "12:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "12:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "12:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "17:1:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Electric Piano",
            "notes": [
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "12:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "12:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "12:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "12:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "13:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "13:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "13:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "14:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "14:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "15:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "15:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "16:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "16:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "16:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "16:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "17:1:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Violin",
            "notes": [
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "6:2:0",
                    "velocity": 0.02
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "7:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "9:1:0",
                    "velocity": 0.02
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "10:3:0",
                    "velocity": 0.02
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "12:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "13:1:1",
                    "velocity": 0.02
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "14:2:3",
                    "velocity": 0.02
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "16:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "17:1:1",
                    "velocity": 0.02
                }
            ]
        },
        {
            "name": "Bass",
            "notes": [
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.39
                }
            ]
        }
    ],
    structure: [
        { type: 'INTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["(A melody on a lute...)", "(Listen closely...)"] },
        { type: 'VERSE', duration: 32, rhythm: 'MINIMAL', lyrics: ["There once was a mighty Demon King", "Stop me if you've heard this one before", "He was in total control, he feasted on souls", "The world trembled when he roared"] },
        { type: 'VERSE', duration: 32, rhythm: 'MINIMAL', lyrics: ["But then some Hunters sang some songs", "Now all he does is starve", "Can't get at the souls, and his flame grows cold", "Just a whisper in the dark"] },
        { type: 'CHORUS', duration: 32, rhythm: 'MINIMAL', lyrics: ["And will he let the fire go out?", "Is this the end of him now?", "Dying King with a crumbling crown?", "Will he let the fire go out?"] },
        { type: 'BRIDGE', duration: 16, rhythm: 'BUILDUP', lyrics: ["The flame is flickering low...", "Do you have the strength to reignite?", "Or will you fade into the night?"] },
        { type: 'CHORUS', duration: 32, rhythm: 'MINIMAL', lyrics: ["And will he let the fire go out?", "Is this the end of him now?", "Dying King with a crumbling crown?", "Will he let the fire go out?"] },
        { type: 'OUTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["(Will he let it go out?)", "(Just a whisper...)", "(In the dark.)"] }
    ],
    musicalData: {
        keyRoot: "A", // Am context
        scale: "minor",
        bpm: 95, // Slower, storytelling tempo
        defaultTheme: {
            chordProgression: [0, 5, 2, 6],
            bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
            melodyPattern: [0, 2, 3, 0, null, 0, null, 0]
        },
        themes: {
            INTRO: {
                chordProgression: [0, 0, 0, 0],
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0],
                // Lute-like arpeggio (Bipa simulation)
                melodyPattern: [0, 4, 7, 12, 7, 4, 0, null, 0, 4, 7, 12, 7, 4, 0, null]
            },
            VERSE: {
                chordProgression: [0, 2, 4, 0], // i - III - v - i (Storytelling feel)
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
                melodyPattern: [0, 0, 0, 2, 3, 2, 0, -2, 0, 0, null, null, null, null, null, null]
            },
            CHORUS: {
                chordProgression: [5, 0, 6, 4], // VI - i - VII - v
                bassPattern: [1, 0, 1, 1, 0, 1, 0, 1], // Energy picks up
                melodyPattern: [7, 7, 7, 5, 4, 2, 0, 0, 7, 7, 7, 9, 7, null, 5, 4]
            },
            BRIDGE: {
                chordProgression: [2, 4, 5, 4], 
                bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
                melodyPattern: [0, 2, 3, 5, 7, 5, 3, 2, 0, null, null, null, null, null, null, null]
            }
        }
    }
};
